module.exports = __webpack_public_path__ + "static/media/home_banner_8.d290d703.jpg";